/**
 * Instruções de local de retirada conforme o destino da carga.
 *
 * - Bissau: endereço físico + Edimilson
 * - Lisboa (Portugal): endereço físico + telefone local
 * - Demais: orientação genérica (sem contato específico)
 */

const PICKUP_ADDRESS_BISSAU =
  'Chapa de Bissau, subida da Cabana, ao lado da Farmácia Mara.';

const PICKUP_ADDRESS_LISBOA =
  // 'Rua das Cachoeiras 182 Lisboa Estacal Novo\nSANTA IRIA DE AZOIA';
  'Rua das Eiras n 51-1B 2725-297\nMem Martins';

const PICKUP_ADDRESS_OTHER = 'Consultar endereço de retirada';

const PICKUP_CONTACT_BISSAU = {
  name: 'Edimilson',
  phone: '955 139 049',
  tel: '+245955139049',
};

const PICKUP_CONTACT_LISBOA = {
  name: 'Hartiaga',
  // name: 'Marilo',
  phone: '+55 11 98416-9075 (WhatsApp)',
  // phone: '+351 920 736 990',
  // tel: '+351920736990',
};

export const normalizeDestinoKey = destination =>
  String(destination || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const isDestinoBissau = destination => {
  const d = normalizeDestinoKey(destination);
  return (
    d.includes('bissau') ||
    d.includes('guine-bissau') ||
    d.includes('guine bissau')
  );
};

/** Lisboa / Portugal (mesmo ponto de retirada). */
export const isDestinoLisboa = destination => {
  const d = normalizeDestinoKey(destination);
  if (!d) return false;
  return (
    d.includes('lisboa') ||
    d.includes('lisbon') ||
    d === 'lisbo' ||
    d.includes('portugal') ||
    d === 'pt'
  );
};

/** @deprecated Use isDestinoLisboa */
export const isDestinoPortugal = isDestinoLisboa;

/** Nome amigável do destino no rótulo "Local da retirada — …". */
export const getPickupDestinationLabel = destination => {
  if (isDestinoBissau(destination)) return 'Bissau';
  if (isDestinoLisboa(destination)) return 'Lisboa';
  const raw = String(destination || '').trim();
  return raw || '—';
};

/** Texto exibido em "Local da retirada". */
export const getPickupLocationText = destination => {
  if (isDestinoBissau(destination)) return PICKUP_ADDRESS_BISSAU;
  if (isDestinoLisboa(destination)) return PICKUP_ADDRESS_LISBOA;
  return PICKUP_ADDRESS_OTHER;
};

/**
 * Contato no local (ou null quando não há contato específico).
 * @returns {{ name: string, phone: string, tel: string } | null}
 */
export const getPickupContact = destination => {
  if (isDestinoBissau(destination)) return PICKUP_CONTACT_BISSAU;
  if (isDestinoLisboa(destination)) return PICKUP_CONTACT_LISBOA;
  return null;
};
